import { render, staticRenderFns } from "./EmployeesReport.vue?vue&type=template&id=2b40a0c0"
import script from "./EmployeesReport.vue?vue&type=script&lang=js"
export * from "./EmployeesReport.vue?vue&type=script&lang=js"
import style0 from "./EmployeesReport.vue?vue&type=style&index=0&id=2b40a0c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports